import type { Release } from '../releases.ts';

export default {
  version: '1.6.5',
  date: '2026-10-27',
  title: 'Portrait and square videos in the player',
  summary: [
    'Portrait and square videos show whole in the player instead of cropped',
  ],
  upgradeSummary: [
    'No migration and no new settings; storage agents need no update',
  ],
  upgradeGuide: 'upgrading-to-165',
  beforeUpgrade: [
    'No migration and no new settings. Web app only: storage agents need no update (docs/deployment.md, “Upgrading to 1.6.5”)',
    'Rolling back to 1.6.4: git checkout v1.6.4 and docker compose up -d --build',
  ],
  features: [],
  fixes: [
    'A portrait or square video showed on the asset page as a landscape frame filled with a zoomed, cropped middle of the picture: the video now fills the player stage and shows whole, pillarboxed, also in the editor’s Source viewer and in Intake',
    'A portrait still image in Fit mode on the asset page, or in the editor’s Source viewer, ran past the bottom of the stage; it now fits',
  ],
} satisfies Release;
